import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  constructor(private http: HttpService) {}

  getNotificationList(page: number, limit: number): Observable<any> {
    return this.http
      .request('get', `/v1/admin/notification?page=${page}&limit=${limit}`)
      .pipe(map((response: any) => response.data));
  }


  createPublicNotification(title: string, message: string): Observable<any> {
    return this.http.request('post', '/v2/admin/notification-all-users', {
      title,
      message
    })
  }

  createPrivateNotification(title: string, message: string, userId: number): Observable<any> {
    return this.http.request('post', '/v2/admin/notification-single-user', {
      title,
      userId,
      message
    })
  }
}
